import http from 'axios'
import { formatFiltresToAxiosParams } from './utils/filtres.utils'

export default {
  getAtelierCultureVerrouillage: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/verrouillage`)
  },
  getResumeSyntheseCulture: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese/${codeTypeCulture}/resume`)
  },
  getResumePrixEquilibre: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese/${codeTypeCulture}/prix-equilibre`)
  },
  getRepartitionChiffreAffaires: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/chiffre-affaires/part`)
  },
  getRepartitionChiffreAffairesParCulture: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/chiffre-affaires`)
  },
  getEvolutionChiffreAffaires: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/chiffre-affaires/evolution`)
  },
  getRepartitionChiffreAffairesCulturesGroupe: (numtiers, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/chiffre-affaires/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionChiffreAffairesGroupe: (numtiers, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/chiffre-affaires/part/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionMainOeuvre: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/main-oeuvre`)
  },
  getRepartitionMainOeuvreGroupe: (numtiers, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/repartition/main-oeuvre/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  construireResumeGroupeRepartitionPrixEquilibre: (numtiers, params) => {
    return http.get(`/web/v1/${numtiers}/cloture/${params.anneeRecolte}/synthese/${params.codeGraine}/prix-equilibre/groupe?${formatFiltresToAxiosParams(params.filtres)}`)
  },
  getResumeCloture: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/resume/${codeTypeCulture}`)
  },
  getEvolutionResumeCloture: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/resume/${codeTypeCulture}/evolution`)
  },
  getGroupeResumeCloture: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/resume/${codeTypeCulture}/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRestitutionChargeFixe: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/fixe`)
  },
  getRestitutionChargeVariable: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/variable`)
  },
  getRestitutionCoproduit: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/coproduit`)
  },
  getRestitutionAutresProduits: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/autre`)
  },
  getEvolutionChargeFixe: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/fixe/evolution`)
  },
  getEvolutionChargeVariable: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/variable/evolution`)
  },
  getEvolutionCoproduit: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/coproduit/evolution`)
  },
  getEvolutionAutresProduits: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/autre/evolution`)
  },
  getGroupeChargeFixe: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/fixe/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getGroupeChargeVariable: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/charge/variable/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getGroupeCoproduit: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/coproduit/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getGroupeAutresProduits: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/restitution/${codeTypeCulture}/produit/autre/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionTresorerie: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/repartition`)
  },
  getEvolutionTresorerie: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/evolution`)
  },
  getTresorerieDisponible: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/${codeTypeCulture}`)
  },
  getEvolutionTresorerieCulture: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/${codeTypeCulture}/evolution`)
  },
  getTresorerieDisponibleGroupe: (numtiers, anneeRecolte, codeTypeCulture, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/${codeTypeCulture}/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getRepartitionTresorerieGroupe: (numtiers, anneeRecolte, filtres) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/groupe?${formatFiltresToAxiosParams(filtres)}`)
  },
  getMatriceGainTresorerie: (numtiers, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/tresorerie/${codeTypeCulture}/matrice`)
  },
}
